// src/config/access-control.config.ts
// Access control configuration for Better Auth organization permissions (Frontend)
// This is a mirror of apps/backend/src/db/access-control.config.ts for the client side

import { createAccessControl } from "better-auth/plugins/access";
import { defaultStatements, adminAc, ownerAc, memberAc } from 'better-auth/plugins/organization/access';

/**
 * Statement definition: Resources and their available actions
 * Extends Better Auth's default statements with custom resources
 */
export const statement = {
  ...defaultStatements,  // organization, member, invitation (from Better Auth)
  asset: ["create", "read", "update", "delete", "share"],
  project: ["create", "read", "update", "delete", "share"],
} as const;

// Create access control instance
export const ac = createAccessControl(statement);

/**
 * Owner Role: Full access to all resources in organization
 * - All organization management permissions
 * - Full asset management (CRUD + share)
 * - Full project management (CRUD + share)
 */
export const owner = ac.newRole({
  ...ownerAc.statements,  // Inherit organization owner permissions
  asset: ["create", "read", "update", "delete", "share"],
  project: ["create", "read", "update", "delete", "share"],
});

/**
 * Admin Role: Can manage assets and projects, limited org permissions
 * - Most organization permissions (cannot delete org)
 * - Full asset management (CRUD + share)
 * - Full project management (CRUD + share)
 */
export const admin = ac.newRole({
  ...adminAc.statements,  // Inherit organization admin permissions
  asset: ["create", "read", "update", "delete", "share"],
  project: ["create", "read", "update", "delete", "share"],
});

/**
 * Member Role: Can create and view resources
 * - Limited organization permissions
 * - Can create new assets and view existing ones
 * - Can view projects
 */
export const member = ac.newRole({
  ...memberAc.statements,  // Inherit organization member permissions
  asset: ["create", "read"],
  project: ["read"],
});

/**
 * Viewer Role: Read-only access (optional)
 * - No organization management permissions
 * - Can only read assets and projects
 */
export const viewer = ac.newRole({
  asset: ["read"],
  project: ["read"],
});
